import React from "react";
import { TableCell, TableHead, TableRow } from "@material-ui/core";

export const getEnvironmentHeader = () => (
  <TableHead>
    <TableRow>
      <TableCell>Qmlativ Environment Name</TableCell>
      <TableCell>API Url</TableCell>
      <TableCell>Is Development Environment</TableCell>
      <TableCell></TableCell>
    </TableRow>
  </TableHead>
);

export const getAccessHeader = () => (
  <TableHead>
    <TableRow>
      <TableCell>Name</TableCell>
      <TableCell>Key</TableCell>
      <TableCell>Is Active</TableCell>
      <TableCell>Effective Date</TableCell>
      <TableCell>Expiration Date</TableCell>
      <TableCell></TableCell>
    </TableRow>
  </TableHead>
);
